export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_q02_a.4bcba266.png";